import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'plannings'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'Instalación' },
  CENTER: { label: 'Centro' },
  SECTOR: { column: 'sectors.name', label: 'Región' },
  REGION: { column: 'regions.name', label: 'Estado' },
  STATUS: { column: 'planning_status_catalog.name', label: 'Estatus' },
  MUNICIPALITY: false,
  TENANT: false,
  USER: {},
})

export default {
  key: DATASET_KEY,
  label: 'Planeación',
  timeColumn: 'plannings.created_at',
  permission: { action: 'read', subject: 'Planning' },

  tables: {
    plannings: ["id", "activity_type", "user_id", "status_id", "created_at", "updated_at"],
    planning_status_catalog: ["id", "name", "code", "created_at", "updated_at"],
    planning_logs: ["id", "planning_id", "user_id", "status_id", "comment", "created_at", "updated_at"],
    planning_items_tempaltes_op: ["id", "planning_id", "reference_id", "created_at", "updated_at"],
    planning_items: ["id", "planning_id", "unit_id", "id_sector", "id_region", "user_id", "target_date", "start_date", "is_scheduled", "comment", "created_at", "updated_at"],
    planning_item_status_changes: ["id", "planning_id", "from_status_id", "to_status_id", "changed_by_user_id", "comment", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
    // field2: 'planning_status_catalog.name',
  },

  csvConfig: {
    withTables: 'plannings',
    columns: 'plannings.activity_type,plannings.created_at,plannings.updated_at,planning_status_catalog.name,planning_status_catalog.created_at,planning_status_catalog.updated_at,planning_logs.created_at,planning_logs.updated_at,planning_items_tempaltes_op.created_at,planning_items_tempaltes_op.updated_at,planning_items.start_date,planning_items.target_date,planning_items.is_scheduled,planning_items.comment,planning_items.created_at,planning_items.updated_at,planning_item_status_changes.comment,planning_item_status_changes.created_at,planning_item_status_changes.updated_at,users.user,users.email,users.name,users.first_name,users.second_name,units.description,units.active,centers.name,municipalities.name,sectors.name,regions.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'centers.name', label: 'Centro' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'units.description', label: 'Inmueble' },
    //{ key: 'units.active', label: 'Estatus' },
    { key: 'plannings.activity_type', label: 'Tipo de actividad' },
    { key: 'planning_items.is_scheduled', label: 'Programado' },
    { key: 'planning_items.start_date', label: 'Fecha inicio', defaultParams: { freq: '1mo' } },
    { key: 'planning_items.target_date', label: 'Fecha objetivo', defaultParams: { freq: '1mo' } },
    { key: 'planning_items.comment', label: 'Comentario' },
    { key: 'planning_items.created_at', label: 'Fecha de creación (Item)', defaultParams: { freq: '1mo' } },
    { key: 'planning_items.updated_at', label: 'Fecha de actualización (Item)', defaultParams: { freq: '1mo' } },
    { key: 'planning_items_tempaltes_op.reference_id', label: 'Referencia' },
    { key: 'planning_items_tempaltes_op.created_at', label: 'Fecha de creación (Referencia)', defaultParams: { freq: '1mo' } },
    { key: 'planning_items_tempaltes_op.updated_at', label: 'Fecha de actualización (Referencia)', defaultParams: { freq: '1mo' } },
    { key: 'planning_status_catalog.name', label: 'Estatus' },
    { key: 'planning_status_catalog.code', label: 'Código estatus' },
    { key: 'planning_status_catalog.created_at', label: 'Fecha de creación (Estatus)', defaultParams: { freq: '1mo' } },
    { key: 'planning_status_catalog.updated_at', label: 'Fecha de actualización (Estatus)', defaultParams: { freq: '1mo' } },
    { key: 'plannings.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'plannings.updated_at', label: 'Fecha de actualización' },
    { key: 'planning_logs.comment', label: 'Comentario (Bitácora)' },
    { key: 'planning_logs.created_at', label: 'Fecha de creación (Bitácora)', defaultParams: { freq: '1mo' } },
    { key: 'planning_logs.updated_at', label: 'Fecha de actualización (Bitácora)', defaultParams: { freq: '1mo' } },
    { key: 'planning_item_status_changes.comment', label: 'Comentario (Cambio de estatus)' },
    { key: 'planning_item_status_changes.created_at', label: 'Fecha de creación (Cambio de estatus)', defaultParams: { freq: '1mo' } },
    { key: 'planning_item_status_changes.updated_at', label: 'Fecha de actualización (Cambio de estatus)', defaultParams: { freq: '1mo' } },
    { key: 'users.user', label: 'Usuario' },
    { key: 'users.email', label: 'Correo electrónico' },
    { key: 'users.name', label: 'Nombre' },
    { key: 'users.first_name', label: 'Primer nombre' },
    { key: 'users.second_name', label: 'Segundo nombre' },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'plannings.activity_type', 'Tipo de actividad', 'type'),
    embedFilter(DATASET_KEY, 'planning_status_catalog.code', 'Código estatus', 'status_code'),
    embedFilter(DATASET_KEY, 'planning_items_tempaltes_op.reference_id', 'Referencia', 'reference'),
    embedFilter(DATASET_KEY, 'users.user', 'Usuario', 'user_username'),
    embedFilter(DATASET_KEY, 'users.email', 'Correo electrónico', 'user_email'),
    embedFilter(DATASET_KEY, 'users.name', 'Nombre', 'user_name'),
    {
      key: 'level',
      label: 'Programado',
      filterType: 'where',
      whereColumn: 'planning_items.is_scheduled',
      optionsConfig: {
        type: 'embed',
        dataset: DATASET_KEY,
        by: 'planning_items.is_scheduled',
        mapItem: item => { const v = Object.values(item)[0]; return { value: v, label: v === 1 ? 'Sí' : 'No' } },
        valueField: 'value',
      },
    },
    embedFilter(DATASET_KEY, 'planning_logs.comment', 'Comentario (Bitácora)', 'planning_log_comment'),
    embedFilter(DATASET_KEY, 'planning_items.comment', 'Comentario', 'planning_item_comment'),
    embedFilter(DATASET_KEY, 'planning_item_status_changes.comment', 'Comentario (Cambio de estatus)', 'planning_item_status_change_comment'),
    embedFilter(DATASET_KEY, 'users.first_name', 'Primer nombre', 'user_first_name'),
    embedFilter(DATASET_KEY, 'users.second_name', 'Segundo nombre', 'user_second_name'),
    {
      key: 'unit_active',
      label: 'Estatus',
      filterType: 'where',
      whereColumn: 'units.active',
      optionsConfig: {
        type: 'embed',
        dataset: DATASET_KEY,
        by: 'units.active',
        mapItem: item => { const v = Object.values(item)[0]; return { value: v, label: v === 1 ? 'Sí' : 'No' } },
        valueField: 'value',
      },
    },
    {
      key: 'start_date',
      label: 'Fecha inicio',
      filterType: 'where-date',
      whereColumn: 'planning_items.start_date',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'target_date',
      label: 'Fecha objetivo',
      filterType: 'where-date',
      whereColumn: 'planning_items.target_date',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_updated_at',
      label: 'Fecha de actualización (Planeación)',
      filterType: 'where-date',
      whereColumn: 'plannings.updated_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_items_created_at',
      label: 'Fecha de creación (Item)',
      filterType: 'where-date',
      whereColumn: 'planning_items.created_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_items_updated_at',
      label: 'Fecha de actualización (Item)',
      filterType: 'where-date',
      whereColumn: 'planning_items.updated_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_status_created_at',
      label: 'Fecha de creación (Estatus)',
      filterType: 'where-date',
      whereColumn: 'planning_status_catalog.created_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_status_updated_at',
      label: 'Fecha de actualización (Estatus)',
      filterType: 'where-date',
      whereColumn: 'planning_status_catalog.updated_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_log_created_at',
      label: 'Fecha de creación (Bitácora)',
      filterType: 'where-date',
      whereColumn: 'planning_logs.created_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_log_updated_at',
      label: 'Fecha de actualización (Bitácora)',
      filterType: 'where-date',
      whereColumn: 'planning_logs.updated_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_item_template_created_at',
      label: 'Fecha de creación (Referencia)',
      filterType: 'where-date',
      whereColumn: 'planning_items_tempaltes_op.created_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_item_template_updated_at',
      label: 'Fecha de actualización (Referencia)',
      filterType: 'where-date',
      whereColumn: 'planning_items_tempaltes_op.updated_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_item_status_change_created_at',
      label: 'Fecha de creación (Cambio de estatus)',
      filterType: 'where-date',
      whereColumn: 'planning_item_status_changes.created_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'planning_item_status_change_updated_at',
      label: 'Fecha de actualización (Cambio de estatus)',
      filterType: 'where-date',
      whereColumn: 'planning_item_status_changes.updated_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'plannings.created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
